export default __webpack_public_path__ + "e0b496884350f67d93b979959dc3a462.png";